// // import { Instagram, Twitter, Linkedin, Github } from 'lucide-react';

// // const Footer = () => {
// //   const currentYear = new Date().getFullYear();

// //   return (
// //     <footer className="py-12 bg-background border-t border-border">
// //       <div className="container mx-auto px-6 max-w-7xl">
// //         <div className="flex flex-col md:flex-row items-center justify-between gap-6">
// //           <a href="/" className="font-display text-3xl tracking-wider text-foreground">
// //             BOLD<span className="text-primary">.</span>
// //           </a>

// //           <div className="flex items-center gap-6">
// //             <a
// //               href="#"
// //               className="w-10 h-10 bg-card border border-border rounded-lg flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary transition-colors"
// //               aria-label="Instagram"
// //             >
// //               <Instagram className="w-5 h-5" />
// //             </a>
// //             <a
// //               href="#"
// //               className="w-10 h-10 bg-card border border-border rounded-lg flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary transition-colors"
// //               aria-label="Twitter"
// //             >
// //               <Twitter className="w-5 h-5" />
// //             </a>
// //             <a
// //               href="#"
// //               className="w-10 h-10 bg-card border border-border rounded-lg flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary transition-colors"
// //               aria-label="LinkedIn"
// //             >
// //               <Linkedin className="w-5 h-5" />
// //             </a>
// //             <a
// //               href="#"
// //               className="w-10 h-10 bg-card border border-border rounded-lg flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary transition-colors"
// //               aria-label="Github"
// //             >
// //               <Github className="w-5 h-5" />
// //             </a>
// //           </div>

// //           <p className="font-body text-sm text-muted-foreground">
// //             © {currentYear} BOLD Studio. All rights reserved.
// //           </p>
// //         </div>
// //       </div>
// //     </footer>
// //   );
// // };

// // export default Footer;





// import { 
//   Twitter, 
//   Facebook, 
//   Youtube, 
//   Instagram, 
//   Linkedin, 
//   Palette, // Standard Lucide fallback for Behance / Portfolio
//   Share2  // Custom SVG used below for Pinterest or standard fallback
// } from 'lucide-react';

// // Custom SVG icon for Pinterest (Lucide does not include official brand logos in newer builds)
// const PinterestIcon = ({ className }) => (
//   <svg 
//     className={className} 
//     fill="currentColor" 
//     viewBox="0 0 24 24"
//   >
//     <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.367 18.62 0 12.017 0z"/>
//   </svg>
// );

// // Custom SVG icon for Behance
// const BehanceIcon = ({ className }) => (
//   <svg 
//     className={className} 
//     fill="currentColor" 
//     viewBox="0 0 24 24"
//   >
//     <path d="M22 7h-7v-2h7v2zm1.726 10c-.442 1.297-2.029 3-4.813 3-3.035 0-5.386-2.178-5.386-5.625 0-3.467 2.284-5.625 5.212-5.625 3.261 0 4.887 2.368 4.675 5.438h-7.371c.089 1.502 1.082 2.267 2.442 2.267 1.387 0 2.035-.55 2.339-1.328h2.902zm-4.918-4.502c-.991 0-1.802.585-2.008 1.502h3.975c-.035-.745-.729-1.502-1.967-1.502zm-10.808 7.502h-8v-14h8.313c2.754 0 4.687 1.114 4.687 3.501 0 1.488-.8 2.451-1.892 2.973 1.425.431 2.392 1.523 2.392 3.238 0 2.688-2.115 4.288-5.5 4.288zm-5-8.5h4.25c1.021 0 1.833-.423 1.833-1.387 0-1.023-.833-1.363-1.833-1.363h-4.25v2.75zm0 6h4.5c1.171 0 2.083-.456 2.083-1.55 0-1.121-.912-1.525-2.083-1.525h-4.5v3.075z"/>
//   </svg>
// );

// const Footer = () => {
//   const currentYear = new Date().getFullYear();

//   const socialLinks = [
//     {
//       name: 'Twitter / X',
//       url: 'https://twitter.com/ColorStencil',
//       icon: Twitter,
//     },
//     {
//       name: 'Facebook',
//       url: 'https://www.facebook.com/colorstencilcreatives',
//       icon: Facebook,
//     },
//     {
//       name: 'YouTube',
//       url: 'https://www.youtube.com/channel/UCXQvxKv3U0H4C4V8LFFtqVA',
//       icon: Youtube,
//     },
//     {
//       name: 'Instagram',
//       url: 'https://www.instagram.com/colorstencil/',
//       icon: Instagram,
//     },
//     {
//       name: 'Pinterest',
//       url: 'https://in.pinterest.com/colorstencil/',
//       icon: PinterestIcon,
//     },
//     {
//       name: 'Behance',
//       url: 'https://www.behance.net/colorstencilCS',
//       icon: BehanceIcon,
//     },
//     {
//       name: 'LinkedIn',
//       url: 'https://www.linkedin.com/company/colorstencil',
//       icon: Linkedin,
//     },
//   ];

//   return (
//     <footer className="py-12 bg-background border-t border-border">
//       <div className="container mx-auto px-6 max-w-7xl">
//         <div className="flex flex-col md:flex-row items-center justify-between gap-6">
//           <a href="/" className="font-display text-3xl tracking-wider text-foreground">
//             BOLD<span className="text-primary">.</span>
//           </a>

//           <div className="flex flex-wrap items-center justify-center gap-4">
//             {socialLinks.map((social) => {
//               const IconComponent = social.icon;
//               return (
//                 <a
//                   key={social.name}
//                   href={social.url}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="w-10 h-10 bg-card border border-border rounded-lg flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary transition-colors"
//                   aria-label={social.name}
//                 >
//                   <IconComponent className="w-5 h-5" />
//                 </a>
//               );
//             })}
//           </div>

//           <p className="font-body text-sm text-muted-foreground text-center md:text-right">
//             © {currentYear} Colorstencil All rights reserved.
//           </p>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;





import { 
  Twitter, 
  Facebook, 
  Youtube, 
  Instagram, 
  Linkedin, 
  Palette, // Standard Lucide fallback for Behance / Portfolio
  Share2  // Custom SVG used below for Pinterest or standard fallback
} from 'lucide-react';
import logo from '../assets/logo.png';

// Custom SVG icon for Pinterest (Lucide does not include official brand logos in newer builds)
const PinterestIcon = ({ className }) => (
  <svg 
    className={className} 
    fill="currentColor" 
    viewBox="0 0 24 24"
  >
    <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.367 18.62 0 12.017 0z"/>
  </svg>
);

// Custom SVG icon for Behance
const BehanceIcon = ({ className }) => (
  <svg 
    className={className} 
    fill="currentColor" 
    viewBox="0 0 24 24"
  >
    <path d="M22 7h-7v-2h7v2zm1.726 10c-.442 1.297-2.029 3-4.813 3-3.035 0-5.386-2.178-5.386-5.625 0-3.467 2.284-5.625 5.212-5.625 3.261 0 4.887 2.368 4.675 5.438h-7.371c.089 1.502 1.082 2.267 2.442 2.267 1.387 0 2.035-.55 2.339-1.328h2.902zm-4.918-4.502c-.991 0-1.802.585-2.008 1.502h3.975c-.035-.745-.729-1.502-1.967-1.502zm-10.808 7.502h-8v-14h8.313c2.754 0 4.687 1.114 4.687 3.501 0 1.488-.8 2.451-1.892 2.973 1.425.431 2.392 1.523 2.392 3.238 0 2.688-2.115 4.288-5.5 4.288zm-5-8.5h4.25c1.021 0 1.833-.423 1.833-1.387 0-1.023-.833-1.363-1.833-1.363h-4.25v2.75zm0 6h4.5c1.171 0 2.083-.456 2.083-1.55 0-1.121-.912-1.525-2.083-1.525h-4.5v3.075z"/>
  </svg>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      name: 'Twitter / X',
      url: 'https://twitter.com/ColorStencil',
      icon: Twitter,
    },
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/colorstencilcreatives',
      icon: Facebook,
    },
    {
      name: 'YouTube',
      url: 'https://www.youtube.com/channel/UCXQvxKv3U0H4C4V8LFFtqVA',
      icon: Youtube,
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/colorstencil/',
      icon: Instagram,
    },
    {
      name: 'Pinterest',
      url: 'https://in.pinterest.com/colorstencil/',
      icon: PinterestIcon,
    },
    {
      name: 'Behance',
      url: 'https://www.behance.net/colorstencilCS',
      icon: BehanceIcon,
    },
    {
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/company/colorstencil',
      icon: Linkedin,
    },
  ];

  return (
    <footer className="py-12 bg-background border-t border-border">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <a href="/" className="inline-block">
            <img src={logo} alt="Logo" className="h-8 w-auto" />
          </a>

          <div className="flex flex-wrap items-center justify-center gap-4">
            {socialLinks.map((social) => {
              const IconComponent = social.icon;
              return (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-card border border-border rounded-lg flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary transition-colors"
                  aria-label={social.name}
                >
                  <IconComponent className="w-5 h-5" />
                </a>
              );
            })}
          </div>

          <p className="font-body text-sm text-muted-foreground text-center md:text-right">
            © {currentYear} Colorstencil All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;